import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';

import SiteManagementLink from 'components/Common/SiteManagementLink';
import {getTypeLabel} from 'components/Common/siteTypesLabels';

import styles from './SiteListTable.module.scss';

const SiteListTable = ({filteredList}) => {
  return (
    <Table basic="very" compact="very" className={styles.SiteListTable}>
      <Table.Body>
        {filteredList.length === 0 ? (
          <Table.Row key="noSites">
            <Table.Cell></Table.Cell>
            <Table.Cell>No sites match your current filters.</Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        ) : (
          filteredList.map(site => (
            <Table.Row key={site.id}>
              <Table.Cell>
                <SiteManagementLink type={site.type} projectName={site.name} showIcon={false} />
              </Table.Cell>
              <Table.Cell textAlign="right">{getTypeLabel(site.type)}</Table.Cell>
              <Table.Cell textAlign="center">
                <SiteManagementLink type={site.type} projectName={site.name} showIcon />
              </Table.Cell>
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  );
};

SiteListTable.propTypes = {
  filteredList: PropTypes.array.isRequired,
};

export default SiteListTable;
